'use client';

import dynamic from 'next/dynamic';

const BookPageContentWithNoSSR = dynamic(
  () => import('./components/BookPageContent/BookPageContent'),
  { ssr: false }
);

const BookingPage = () => <BookPageContentWithNoSSR />;

export default BookingPage;
